export default __webpack_public_path__ + "static/media/left_click.9b2f02a5.gif";